import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { JourneyPortal } from '@app/core/models/journey/journey-portal';
import { AccessMedia } from '@app/core/models/models';
import { HasJourneyEnded } from '@app/shared/pipes/has-journey-ended.pipe';
import { HasJourneyFeeCapingReach } from '@app/shared/pipes/has-journey-fee-caping-reach.pipe';

@Component({
  selector: 'pp-activity-detail',
  templateUrl: './activity-detail.component.html',
  styleUrls: ['./activity-detail.component.css']
})

export class ActivityDetailComponent implements OnInit {
  support: string;
  browserLang = navigator.language;

  @Input()
  journey: JourneyPortal;

  @Input()
  accessMedia: AccessMedia;

  @Input()
  displayTrips: boolean;

  journeyFeeCappingStatus: string;
  hasJourneyEnded: boolean;

  constructor(private datePipe: DatePipe, private hasJourneyFeeCapingReachPipe: HasJourneyFeeCapingReach, private hasJourneyEndedPipe: HasJourneyEnded) {}

  ngOnInit() {
    if (this.accessMedia && this.accessMedia.accessMediaDescription) {
      const label = (this.accessMedia.accessMediaHolder && this.accessMedia.accessMediaHolder.accessMediaName) ? `${this.accessMedia.accessMediaHolder.accessMediaName} ` : '';
      const maskedPAN = this.accessMedia.accessMediaDescription.substr(this.accessMedia.accessMediaDescription.lastIndexOf('#'));
      const expirationDate = this.datePipe.transform(this.accessMedia.accessMediaExpirationDate, 'MM/yyyy');
      this.support = `${label}${maskedPAN} ${expirationDate}`;
    }
    this.journeyFeeCappingStatus = this.hasJourneyFeeCapingReachPipe.transform(this.journey.taps);
    this.hasJourneyEnded = this.hasJourneyEndedPipe.transform(this.journey);
  }
}
